import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { HttpStatusError } from "@/api/classifier";
import { removeFromGoldenDataset } from "@/api/reviews";
import { goldenDatasetStatusQueryKey } from "./goldenDatasetStatusQueryKey";

const NOT_FOUND_STATUS = 404;

export function useRemoveFromGoldenDataset() {
  const queryClient = useQueryClient();
  const invalidateStatus = (encounterId: string) =>
    queryClient.invalidateQueries({ queryKey: goldenDatasetStatusQueryKey(encounterId) });

  return useMutation({
    mutationFn: removeFromGoldenDataset,
    onSuccess: ({ datasetId }, encounterId) => {
      toast.success(`Removed from ${datasetId}`);
      return invalidateStatus(encounterId);
    },
    onError: (error: Error, encounterId) => {
      toast.error(error.message);
      if (error instanceof HttpStatusError && error.status === NOT_FOUND_STATUS) {
        return invalidateStatus(encounterId);
      }
    },
  });
}
